import { render } from "./Laboratory.vue?vue&type=template&id=6d8a9110"
import script from "./Laboratory.vue?vue&type=script&lang=js"
export * from "./Laboratory.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/cts-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__